<div class="header">
    <header id="header" id="home">
        <div class="header-top">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-sm-6 col-8 header-top-left no-padding">
                        <ul>
                            <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                            <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                            <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                            <li><a href="#"><i class="fa fa-behance"></i></a></li>
                        </ul>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-4 header-top-right no-padding">
                        <a href="tel:+953 012 3654 896" style="margin-right: 30px;"><img class="image-icon" src="../../../assets/images/phone-icon.png" alt="" title="" /> <span class="text">+953 012 3654 896</span></a>
                        <a href="mailto:support@colorlib.com"><img class="image-icon" src="../../../assets/images/mail-icon.png" alt="" title="" /> <span class="text">support@colorlib.com</span></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="container main-menu">
            <div class="row align-items-center justify-content-between d-flex">
                <div id="logo">
                    <a href="index.html"><img src="../../../assets/images/logo.png" width="313px" alt="" title="" /></a>
                </div>

                <div class="search">
                    <input type="text" value="" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = '';}">
                    <fa-icon [icon]="faSearch" [styles]="{'position': 'relative', 'left': '30px'}" size="1x"></fa-icon><input type="submit" value="SEARCH">
                </div>
                <div>
                    <a href="/contact"><button class="contact-btn" type="submit">Liên Hệ Báo Giá</button></a>
                </div>
                <div class="clearfix"> </div>
            </div>
        </div>
    </header>

    <div class="bottom-header" id="myHeader">
        <div class="container row margin-auto">
            <div class="col-3 row">
                <app-sidebar></app-sidebar>
            </div>
            <div class="header-bottom-left col-9">

                <nav id="nav-menu-container">
                    <ul class="nav-menu">
                        <li><a href="">Trang Chủ</a></li>
                        <li><a href="/pricetable">Bảng Giá</a></li>
                        <li><a href="/services">Dịch Vụ</a></li>
                        <li><a href="/guildline">Hướng Dẫn</a></li>
                        <li><a href="/information">Giới Thiệu</a></li>
                        <li><a href="/contact">Liên Hệ</a></li>
                        <li><a href="/policies">Chính Sách</a></li>
                        <li><a href="contact.html">Tin Tức</a></li>
                    </ul>
                </nav>
            </div>

            <div class="clearfix"> </div>
        </div>
    </div>
</div>

<script>
    window.onscroll = function() {
        myFunction()
    };

    var header = document.getElementById("myHeader");
    var sticky = header.offsetTop;

    function myFunction() {
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }
</script>